export const TIP_PERCENTAGES = [15, 18, 20, 25];

export function discountedSubtotal(totalCents, percentage) {
    if (!Number.isSafeInteger(totalCents) || totalCents < 0 ||
        !Number.isInteger(percentage) || percentage < 0 || percentage > 100) {
        throw new Error("The appointment discount could not be verified.");
    }
    return totalCents - (Math.floor(totalCents / 100) * percentage +
        Math.floor(((totalCents % 100) * percentage + 50) / 100));
}

export function appointmentServices(appointment) {
    if (Array.isArray(appointment?.services) && appointment.services.length) return appointment.services;
    return appointment?.pricing ? [appointment.pricing] : [];
}

export function serviceKey(service, index) {
    return String(service.service_id || `${service.product_id}-${index}`);
}

export function tipCents(tip, totalCents) {
    if (tip?.type === "percent") return Math.round((totalCents * tip.value) / 100);
    if (tip?.type === "custom") return Math.max(0, Math.round(Number(tip.value || 0) * 100));
    return 0;
}

export function isTipValid(tip) {
    if (!tip) return false;
    if (tip.type !== "custom") return true;
    const amount = Number(tip.value);
    return tip.value !== "" && Number.isFinite(amount) && amount >= 0;
}
